<mh-dashboard-widget-card [ready]="ready()">
  <mh-chart-value-widget
    [title]="'concierge.summary.widgets.automation_prefix' | translate"
    [subtitle]="'concierge.summary.widgets.automation_label' | translate"
    [description]="qualificationKey() | translate"
    [product]="'concierge'"
    [enabled]="enabled()"
    [value]="displayValue()"
    [loading]="loading()"
    [error]="error()"
    [route]="'/concierge/summary'"
    [demoRoute]="'/plg/concierge'"
    [showChart]="false"
    [showChange]="false"
    [gaKey]="'corporatedash-viewconcierge-active'"
  />
</mh-dashboard-widget-card>
